var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCornerDoubleDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.91414 1.46967C6.20703 1.17678 6.6819 1.17678 6.9748 1.46967L11.4192 5.91411C11.6337 6.12861 11.6979 6.4512 11.5818 6.73146C11.4657 7.01171 11.1923 7.19444 10.8889 7.19444H7.19447V14.2222C7.19447 15.649 8.35106 16.8056 9.7778 16.8056H16.8056V13.1111C16.8056 12.8078 16.9883 12.5343 17.2686 12.4182C17.5488 12.3021 17.8714 12.3663 18.0859 12.5808L22.5304 17.0252C22.8232 17.3181 22.8232 17.793 22.5304 18.0859L18.0859 22.5303C17.8714 22.7448 17.5488 22.809 17.2686 22.6929C16.9883 22.5768 16.8056 22.3033 16.8056 22V18.3056H9.7778C7.52264 18.3056 5.69447 16.4774 5.69447 14.2222V7.19444H2.00002C1.69668 7.19444 1.4232 7.01171 1.30711 6.73146C1.19103 6.4512 1.25519 6.12861 1.46969 5.91411L5.91414 1.46967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerDoubleDownRight);
export default __webpack_public_path__ + "static/media/corner-double-down-right.923efe893445377d1f06a4eba51ba676.svg";
export { ForwardRef as ReactComponent };